import { useEffect, useState, useContext } from 'react'
import { WindowSizeContext } from 'components/context/WindowSizeProvider';

export default function useSildeCount() {
    const size = useContext(WindowSizeContext)
    const [count, setCount] = useState(3);

    useEffect(() => {
        if (size.width > 2183) {
            setCount(6);
        } else if (size.width > 1921) {
            setCount(5);
        } else {
            setCount(4);
        }
    }, [size.width]);

    return count;
}
